import api from './api'
import { Campanha, CampanhaRequest, SincronizacaoAudiencia, StatusCampanha } from '@/types/campanha'
import { PageResponse } from '@/types/comum'

const BASE_URL = '/api/v1/campanhas'

/*
 * CRUD da campanha. AN-8 (Q-AN8-2): criar, editar, mudar status, excluir e sincronizar a
 * audiência são ADMIN_ONLY; ler (lista e detalhe) é do back-office (OPERADOR+).
 */
export const campanhaService = {
  listar: async (
    page = 0,
    size = 20,
    status?: StatusCampanha
  ): Promise<PageResponse<Campanha>> => {
    const params = new URLSearchParams({ page: String(page), size: String(size) })
    if (status) params.append('status', status)
    return await api.get<PageResponse<Campanha>>(`${BASE_URL}?${params.toString()}`)
  },

  buscar: async (id: string): Promise<Campanha> => {
    return await api.get<Campanha>(`${BASE_URL}/${id}`)
  },

  criar: async (req: CampanhaRequest): Promise<Campanha> => {
    return await api.post<Campanha>(BASE_URL, req)
  },

  atualizar: async (id: string, req: CampanhaRequest): Promise<Campanha> => {
    return await api.put<Campanha>(`${BASE_URL}/${id}`, req)
  },

  /** 422 CAMPANHA_AUDIENCIA_VAZIA ao ativar uma audiência sem nenhum consultor ativo. */
  alterarStatus: async (id: string, status: StatusCampanha): Promise<Campanha> => {
    return await api.patch<Campanha>(`${BASE_URL}/${id}/status`, { status })
  },

  /** 409 CAMPANHA_EM_USO_NO_RANKING quando a campanha é o escopo do ranking. */
  deletar: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`)
  },

  /**
   * Materializa as audiências dinâmicas a partir da projeção de usuários (runbook da carga
   * inicial, AN-8 §2). ADMIN.
   */
  sincronizarAudiencias: async (): Promise<SincronizacaoAudiencia> => {
    return await api.post<SincronizacaoAudiencia>(`${BASE_URL}/audiencia/sincronizar`, {})
  },
}
